<template>
  <div class="cpt-time-selector">
    <el-date-picker
      class="date-picker left"
      v-model="time_config.timestamp_start"
      type="date"
      placeholder=""
      :prefix-icon="'none'"
      :clearable="false"
      :editable="false"
      :picker-options="{
        disabledDate: minDisableData,
      }"
      :format="dateFormat"
    ></el-date-picker>
    <el-time-picker
      class="time-picker left"
      placeholder=""
      v-model="time_config.timestamp_start"
      :picker-options="{}"
      :prefix-icon="'none'"
      :clearable="false"
      :editable="false"
      format="HH:mm"
    ></el-time-picker>
    <div class="time-division"></div>
    <el-time-picker
      class="time-picker right"
      placeholder=""
      v-model="time_config.timestamp_end"
      :picker-options="{}"
      :prefix-icon="'none'"
      :clearable="false"
      :editable="false"
      format="HH:mm"
    ></el-time-picker>
    <el-date-picker
      class="date-picker right"
      v-model="time_config.timestamp_end"
      @change="handleUpdateMaxValue"
      type="date"
      placeholder=""
      :prefix-icon="'none'"
      :clearable="false"
      :editable="false"
      :picker-options="{
        disabledDate: maxDisabledDate,
      }"
      :format="dateFormat"
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'TimeSelector',
  props: {
    dateFormat: {
      type: String,
      default: 'yyyy-MM-dd',
    }
  },
  data() {
    return {
      time_config: {
        timestamp_start: new Date(),
        timestamp_end: new Date(),
      },
    };
  },
  watch: {
    time_config: {
      handler(newVal) {
        this.handleUpdateValue(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleUpdateValue(newVal) {
      this.$emit('updateValue', newVal);
    },
    maxDisabledDate(time) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 将今天的日期设置为00:00:00
      return time.getTime() > today.getTime(); // 如果time是今天的日期之后的日期，则返回true
    },
    minDisableData(time) {
      return time.getTime() > this.time_config.timestamp_end.getTime(); // 如果time是今天的日期之后的日期，则返回true
    },
    handleUpdateMaxValue(maxTime){
      if(maxTime.getTime() < this.time_config.timestamp_start.getTime()){
        this.$set(this.time_config, 'timestamp_start', maxTime)
      }
    }
  },
};
</script>

<style lang="scss">
@import '_css/date_picker.scss';
.cpt-time-selector {

  height: 52px;
  padding: 0 8px 8px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .time-division {
    width: 12px;
    height: 2px;
    background: $d-tx-2;
    margin: 0px 6px;
  }

  .date-picker {
    width: 88px;
    height: 44px;
    background-color: $d-op-s2;

    &.left {
      border-radius: 5px 0px 0px 5px;
    }

    &.right {
      border-radius: 0px 5px 5px 0px;
    }

    .el-input__inner {
      text-align: center;
      padding: 0px;
      border-radius: 0px;
      background-color: transparent;
      color: $d-tx-2;
      font-size: 14px;
    }
  }

  .time-picker {
    width: 50px;
    height: 44px;
    background-color: $d-op-s2;
    &.left {
      margin-left: 1px;
      border-radius: 0px 5px 5px 0px;
    }

    &.right {
      margin-right: 1px;
      border-radius: 5px 0px 0px 5px;
    }

    .el-input__inner {
      text-align: center;
      padding: 0px;
      border-radius: 0px;
      background-color: transparent;
      color: $d-tx-2;
      font-size: 14px;
    }
  }
}
</style>
